import type { IResource } from '@experiences/interfaces';

export const mapTokenScopesToResources = (
    tokenScopes: string[] | undefined,
    externalResources: IResource[] | undefined
): Array<{ resource: string; scopes: string[] }> => {
    if (!tokenScopes || !externalResources) {
        return [];
    }

    const resourceScopeMap: Record<string, string[]> = {};

    tokenScopes.forEach((tokenScope: string) => {
        externalResources.forEach((resource) => {
            const matchingScope = resource.scopes.find((resourceScope) => resourceScope.name === tokenScope);

            if (matchingScope) {
                if (!resourceScopeMap[resource.name]) {
                    resourceScopeMap[resource.name] = [];
                }

                resourceScopeMap[resource.name].push(tokenScope);
            }
        });
    });

    return Object.entries(resourceScopeMap).map(([ resource, scopes ]) => ({
        resource,
        scopes,
    }));
};
